module.exports = __webpack_public_path__ + "img/e-meterai.410b35e6.png";